module.exports = __webpack_public_path__ + "img/icon_set_plus_24.0699038b.svg";